// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"5bbf5036","196":"5bbf5036"}[chunkId] + ".chunk.css";
};